



import {defineComponent, PropType} from "@vue/composition-api";
import HeaderMenu from "@tool/Components/HeaderMenu.vue";
import {HeaderMenuItem, ProjectEntityInterface} from "@tool/tool.types";


export default defineComponent({
    components: {HeaderMenu},
    props: {
        project: {
            type: Object as PropType<ProjectEntityInterface>,
            required: true
        }
    },
    setup(props) {

        const menuItems: HeaderMenuItem[] = [
            {
                'name': 'Build UTM URLs',
                'icon': 'fa-magic',
                'href': route('app.project.builder.index', props.project.slug),
                'active': route().current('app.project.builder.index') as unknown as boolean,
                'desktop': true,
                'hide': false,
                'inertia': true
            },
            {
                'name': 'URLs',
                'icon': 'fa-link',
                'href': route('app.project.urls.index', props.project.slug),
                'active': route().current('app.project.urls.index') as unknown as boolean,
                'desktop': true,
                'hide': false,
                'inertia': true
            },
            {
                'name': 'Short URLs',
                'icon': 'fa-share',
                'href': route('app.project.shorturls.index', props.project.slug),
                'active': route().current('app.project.shorturls.index') as unknown as boolean,
                'desktop': true,
                'hide': false,
                'inertia': true
            },
            {
                'name': 'UTM Parameters',
                'icon': 'fa-tag',
                'href': route('app.project.parameters.index', props.project.slug),
                'active': route().current('app.project.parameters.*') as unknown as boolean,
                'desktop': true,
                'hide': false,
                'inertia': true,
                children: [
                    {
                        name: 'Campaigns',
                        href: route('app.project.parameters.campaigns.index', props.project.slug),
                        active: route().current('app.project.parameters.campaigns.index') as unknown as boolean,
                        desktop: true,
                        hide: false,
                        inertia: true
                    },
                    {
                        name: 'Sources',
                        href: route('app.project.parameters.sources.index', props.project.slug),
                        active: route().current('app.project.parameters.sources.index') as unknown as boolean,
                        desktop: true,
                        hide: false,
                        inertia: true
                    },
                    {
                        name: 'Mediums',
                        href: route('app.project.parameters.mediums.index', props.project.slug),
                        active: route().current('app.project.parameters.mediums.index') as unknown as boolean,
                        desktop: true,
                        hide: false,
                        inertia: true
                    },
                    {
                        name: 'Terms',
                        href: route('app.project.parameters.terms.index', props.project.slug),
                        active: route().current('app.project.parameters.terms.index') as unknown as boolean,
                        desktop: true,
                        hide: false,
                        inertia: true
                    },
                    {
                        name: 'Contents',
                        href: route('app.project.parameters.contents.index', props.project.slug),
                        active: route().current('app.project.parameters.contents.index') as unknown as boolean,
                        desktop: true,
                        hide: false,
                        inertia: true
                    },
                ]
            },
            {
                'name': 'UTM Templates',
                'icon': 'fa-book',
                'href': route('app.project.templates.index', props.project.slug),
                'active': route().current('app.project.templates.index') as unknown as boolean,
                'desktop': true,
                'hide': false,
                'inertia': true
            },
            {
                'name': 'Reports',
                'icon': 'fa-chart-line',
                'href': route('app.project.reports.index', props.project.slug),
                'active': route().current('app.project.reports.*') as unknown as boolean,
                'desktop': true,
                'hide': false,
                'inertia': true,
                children: [
                    {
                        name: 'Overview',
                        href: route('app.project.reports.index', props.project.slug),
                        active: route().current('app.project.reports.index') as unknown as boolean,
                        desktop: true,
                        hide: false,
                        inertia: true
                    },
                    {
                        name: 'Shorturls',
                        href: route('app.project.reports.shorturls.index', props.project.slug),
                        active: route().current('app.project.reports.shorturls.index') as unknown as boolean,
                        desktop: true,
                        hide: false,
                        inertia: true
                    },
                    {
                        name: 'Campaigns',
                        href: route('app.project.reports.campaigns.index', props.project.slug),
                        active: route().current('app.project.reports.campaigns.index') as unknown as boolean,
                        desktop: true,
                        hide: false,
                        inertia: true
                    },
                    {
                        name: 'Sources',
                        href: route('app.project.reports.sources.index', props.project.slug),
                        active: route().current('app.project.reports.sources.index') as unknown as boolean,
                        desktop: true,
                        hide: false,
                        inertia: true
                    },
                    {
                        name: 'Mediums',
                        href: route('app.project.reports.mediums.index', props.project.slug),
                        active: route().current('app.project.reports.mediums.index') as unknown as boolean,
                        desktop: true,
                        hide: false,
                        inertia: true
                    },
                    {
                        name: 'Terms',
                        href: route('app.project.reports.terms.index', props.project.slug),
                        active: route().current('app.project.reports.terms.index') as unknown as boolean,
                        desktop: true,
                        hide: false,
                        inertia: true
                    },
                    {
                        name: 'Contents',
                        href: route('app.project.reports.contents.index', props.project.slug),
                        active: route().current('app.project.reports.contents.index') as unknown as boolean,
                        desktop: true,
                        hide: false,
                        inertia: true
                    },
                ]
            },
            {
                'name': 'Settings',
                'icon': 'fa-cog',
                'href': route('app.project.settings.index', props.project.slug),
                'active': route().current('app.project.settings.index') as unknown as boolean,
                'desktop': true,
                'hide': false,
                'inertia': true
            },
        ];

        return {menuItems};
    }
});
